//标签管理
import http from '../jslibs/axios/http';


// 标签管理 快捷输入标签列表
export const getQuickTagList = data => (http.get('/v1/cms/QuickTag', data))

// 标签管理 新增标签
export const addQuickTag = data => (http.post('/v1/cms/QuickTag', data))

// 标签管理 编辑标签
export const editQuickTag = (data) => (http.put(`/v1/cms/QuickTag/${data.uuid}`, data))

// 标签管理 删除标签
export const deleteQuickTag = uuid => (http.delete(`/v1/cms/QuickTag/${uuid}`))

// 标签管理 获取标签详情
export const getQuickTagDetail = uuid => (http.get(`/v1/cms/QuickTag/${uuid}`))

// 标签管理 获取进度标签表
export const getProgressTagList = data => (http.get('/v1/cms/ProgressTag', data))

// 标签管理 添加进度标签
export const addProgressTag = (data)=> (http.post('/v1/cms/ProgressTag', data))

// 标签管理 编辑进度标签
export const editProgressTag = (data)=> (http.put(`/v1/cms/ProgressTag/${data.uuid}`, data))

// 标签管理 删除进度标签
export const deletelProgressTag = (uuid)=> (http.delete(`/v1/cms/ProgressTag/${uuid}`))

// 标签管理 获取进度标签详情
export const getProgressTagDetail = uuid => (http.get(`/v1/cms/ProgressTag/${uuid}`))
